import type { Search } from "@libs/wire";

/**
 * Narrows a search response down to just the song rows, in the same
 * ranking order the results render in. Feeds `usePrewarmSongs` in
 * `ExploreScreen.tsx`'s `SearchResultsPane`.
 *
 * Kept in its own file (no imports beyond the `Search` type) so it's
 * testable without pulling in `ExploreScreen.tsx`'s full tree (Favourites,
 * ForYou, trpc/queryClient, react-native-mmkv, ...) — mirrors why
 * `patchFreshSongIntoSongsList` lives in its own file for the same reason.
 */
export const selectSearchSongsForPrewarm = (
  searchResults: Search[],
): Extract<Search, { type: "song" }>[] =>
  searchResults.filter(
    (result): result is Extract<Search, { type: "song" }> =>
      result.type === "song",
  );
